<template>
  <div class="special-case-step">
    <GridPanelHeader
      :title="$t('tools.special_cases.parcel_step_description')"
      :grid-ref="$refs.selectedParcelGrid"
      :show-add="canSelectParcels"
      :show-filter="false"
      :show-export="false"
      :show-columns="false"
      @add="openSelector"
    />
    <DxDataGrid
      ref="selectedParcelGrid"
      :data-source="selectedParcels"
      key-expr="uuid"
      :element-attr="gridAttributes"
      :show-borders="true"
      :show-column-lines="true"
      :column-auto-width="true"
      :hover-state-enabled="true"
      :repaint-changes-only="true"
      :row-alternation-enabled="true"
      @row-removing="removeParcel"
    >
      <DxColumn data-field="name" :caption="$t('common.parcel')" />
      <DxColumn data-field="surface" :caption="$t('common.surface_ha')" data-type="number" />
      <DxScrolling mode="standard" show-scrollbar="always" />
      <DxEditing mode="cell" :allowUpdating="true" :allowAdding="false" :allowDeleting="true" :use-icons="true">
        <DxTexts
          :confirm-delete-message="
            $t('common.confirm_delete', {
              title: this.$t('common.product'),
            })
          "
          :confirm-delete-title="$t('common.confirm_delete_title')"
          :save-row-changes="$t('common.save')"
          :cancel-row-changes="$t('common.close')"
          :addRow="$t('common.add_new')"
          :editRow="$t('common.edit')"
          :deleteRow="$t('common.delete')"
        />
      </DxEditing>
    </DxDataGrid>
    <ParcelSelector
      v-if="selectorVisible"
      :visible="selectorVisible"
      :selected-parcel-uuids="selectedParcelUuids"
      :filter-data="parcelFilterData"
      :lock-context-filters="true"
      @close="selectorVisible = false"
      @continue="onParcelsSelected"
    />
  </div>
</template>

<script>
import { DxDataGrid, DxColumn, DxScrolling, DxEditing, DxTexts } from "devextreme-vue/data-grid";
import ParcelSelector from "@/components/ParcelSelector.vue";
import GridPanelHeader from "@/components/DxGrid/GridPanelHeader.vue";

export default {
  name: "SpecialCaseParcelStep",
  components: { DxDataGrid, DxColumn, DxScrolling, DxEditing, DxTexts, ParcelSelector, GridPanelHeader },
  props: {
    formData: { type: Object, required: true },
    options: { type: Object, default: () => ({}) },
    saving: { type: Boolean, default: false },
  },
  data() {
    return {
      gridAttributes: {
        class: "smagria-grid special-case-parcel-grid",
      },
      selectorVisible: false,
    };
  },
  computed: {
    targetUuids() {
      return this.formData.target_uuids || [];
    },
    selectedParcels() {
      return this.formData.target_parcels || [];
    },
    selectedParcelUuids() {
      return this.selectedParcels.map((parcel) => parcel.uuid);
    },
    parcelFilterData() {
      const department = (this.options.departments || []).find((item) => item.uuid === this.formData.department_uuid);
      return {
        season_uuid: this.formData.season_uuid,
        department_uuid: this.formData.department_uuid,
        department_name: department?.name || "",
      };
    },
    canSelectParcels() {
      return !this.saving && !!this.formData.season_uuid && !!this.formData.department_uuid;
    },
  },
  methods: {
    openSelector() {
      this.selectorVisible = true;
    },
    onParcelsSelected(parcels) {
      const selectedParcels = (parcels || []).map(({ uuid, season_on_parcel_uuid, name, surface }) => ({
        uuid,
        season_on_parcel_uuid,
        name,
        surface,
      }));
      this.$emit("input", {
        target_uuids: selectedParcels.map((parcel) => parcel.season_on_parcel_uuid),
        target_parcels: selectedParcels,
      });
      this.selectorVisible = false;
    },
    removeParcel(event) {
      const parcelUuid = event.row.data.uuid;
      const seasonOnParcelUuid = event.row.data.season_on_parcel_uuid;
      this.$emit("input", {
        target_uuids: this.targetUuids.filter((uuid) => uuid !== seasonOnParcelUuid),
        target_parcels: this.selectedParcels.filter((parcel) => parcel.uuid !== parcelUuid),
      });
    },
    validate() {
      return this.targetUuids.length ? [] : [this.$t("tools.special_cases.select_targets")];
    },
  },
};
</script>

<style lang="scss" scoped>
.special-case-parcel-grid {
  height: calc(95vh - 290px) !important;
}
</style>
